import React, { FC, PropsWithChildren } from "react";
import { ChatServerActionLink } from "../../xapp/ChatServerMessage";
import "./ChatChip.scss";

export interface Props {
    readonly option: string | ChatServerActionLink;
    onClick?: (option: string | ChatServerActionLink) => void;
}

const ChatChip: FC<PropsWithChildren<Props>> = props => {
    const option = props.option;

    const className: string = (option as ChatServerActionLink).actionUrl ? "chat-chip chat-chip-link" : "chat-chip";

    return (
        <div onClick={() => props?.onClick(option)} className={className}><span>{typeof option === "object" ? (option as ChatServerActionLink).label : option}</span></div>
    );
}

export default ChatChip;
